export default __webpack_public_path__ + "static/media/Patientio.39ecfa3f.jpg";